export const ExternalSystemNotificationMethod = {
  SNS: 'SNS',
  KINESIS: 'KINESIS',
};
